/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import themeConfig, { colors } from '@/../themeConfig.js'

// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
  const mq = function (query) {
    return window.matchMedia(query).matches
  }

  if ('ontouchstart' in window || window.DocumentTouch) {
    return true
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
  return mq(query)
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  bodyOverlay             : false,
  isVerticalNavMenuActive : true,
  is_touch_device         : is_touch_device(),
  mainLayoutType          : themeConfig.mainLayoutType || 'vertical',
  reduceButton            : themeConfig.sidebarCollapsed,
  verticalNavMenuWidth    : 'default',
  verticalNavMenuItemsMin : false,
  scrollY                 : 0,
  theme                   : 'light',
  themePrimaryColor       : colors.primary,
  isCalendarPopupActive   : false,
  isPaymentsPopupActive   : false,
  isProjectPaymentsPopupActive   : false,
  isFeedbackPopupActive   : false,
  isDSActive              : false,
  isGeneralLogPopupActive : false,
  isMatiPopupActive       : false,
  userIdToActivate        : null,
  isProjectDetailPopupActive: false,
  isNewCardPopupActive   : false,
  isCardCvvPopupActive   : false,
  isRefundCardPopupActive   : false,
  isSimulationPopupActive : false,
  isInvestmentPopupActive: false,
  is2faPopupActive: false,
  isBeneficiaryPopupActive: false,
  isBeneficiaryDetailPopupActive: false,
  isUnauthenticated: false,
  shouldReloadBeneficiariesList: false,
  isBankAccountsPopupActive: false,
  isIncomeSourceProofPopupActive: false,
  runningMatiProcess: false,
  finishedMatiProcess: false,
  isGeneralNoticePopupActive: false,
  isSwitchAccountPopupActive: false,
  finishedMiFielSupplierCMProcess: false,

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null
}

export default state
